var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"wizard-box-nr"},[_vm._v("\n    "+_vm._s(this.header_step)+"/"+_vm._s(this.total_steps)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }